import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=6981c867&scoped=true&"
import script from "./Credit.vue?vue&type=script&lang=js&"
export * from "./Credit.vue?vue&type=script&lang=js&"
import style0 from "./Credit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Credit.vue?vue&type=style&index=1&id=6981c867&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981c867",
  null
  
)

export default component.exports